import { Component, OnInit } from '@angular/core';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { iacOptionInterface } from 'src/app/page_component_item/input-with-autocomplete/input-with-autocomplete.component';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { CustomLabelsService } from 'src/app/page/register-page/register-forms/customer/custom_labels/service/custom-labels.service';
import { mspTableHeaderI } from 'src/app/page_component_item/msp-table/msp-table.component';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';

@Component({
	selector: 'register-form-custom-labels',
	templateUrl: './custom-labels.component.html',
	styleUrls: ['./custom-labels.component.scss'],
})
export class CustomLabelsComponent implements OnInit {
	labels: LabelsInterface = {
		lbl_geral_portugues: '',
		lbl_geral_ingles: '',
		lbl_geral_espanhol: '',
		lbl_geral_eslovaco: '',
		lbl_geral_chines: '',
		lbl_geral_italiano: '',
		lbl_iac_min_char_search: '',
		lbl_geral_nome: '',
		lbl_geral_atualizar: '',
		lbl_geral_registrar: '',
		lbl_criar_novo_item: '',
		lbl_geral_criado_com_sucesso: '',
		lbl_geral_limpar_campos: '',
		lbl_preencha_todos_campos: '',
		lbl_successful_updated: '',
		lbl_geral_buscar: '',
		lbl_kb_criar: '',
	};

	searchHeader: mspTableHeaderI[] = [
		{ name: this.ProfileService.userData().language.toLowerCase(), value: 'lbl_custom_labels', colType: 'text' },
	];

	constructor(
		private LabelsService: LabelsService,
		private ProfileService: ProfileService,
		private NotificationService: NotificationService,
		private CustomLabelsService: CustomLabelsService
	) {}

	paginationStart = 0;
	paginationEnd = 0;

	labelLoad: LabelsInterface[] = [];
	labelLoadIAC: iacOptionInterface[] = [];

	isLoadingLabels = true;
	isLoadingLabelLoad = true;

	isCreatingLabel = false;
	isUpdatingLabel = false;

	selectedLabel: LabelsInterface = {
		id: '-1',
		portuguese: '',
		english: '',
		spanish: '',
		slovak: '',
		chinese: '',
		italian: '',
	};

	crudType: 'update' | 'create';

	ngOnInit(): void {
		this.LabelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLoadingLabels = false;
		});

		this.CustomLabelsService.getcustomLabelLoad().subscribe((labelLoad) => {
			this.labelLoad = labelLoad;

			for (const label of this.labelLoad) {
				const labelIAC: iacOptionInterface = {
					name: label.id,
					secondName: label[this.ProfileService.userData().language],
					value: label.id,
					commonGroup: label[this.ProfileService.userData().language],
				};

				this.labelLoadIAC.push(labelIAC);
			}

			this.sort(false);
			this.isLoadingLabelLoad = false;
		});
	}

	setLabel(label?: string): void {
		if (this.isCreatingLabel || this.isUpdatingLabel) return;

		if (label) {
			this.labelLoad.find((labels) => {
				if (labels.id === label) {
					this.selectedLabel = labels;
					this.crudType = 'update';
				}
			});
		} else {
			this.selectedLabel = {
				id: '',
				portuguese: '',
				english: '',
				spanish: '',
				slovak: '',
				chinese: '',
				italian: '',
			};

			this.crudType = 'create';
		}
	}

	isAllFieldsFullfiled(): boolean {
		return (
			this.selectedLabel.id != '' &&
			this.selectedLabel.portuguese != '' &&
			this.selectedLabel.english != '' &&
			this.selectedLabel.spanish != '' &&
			this.selectedLabel.slovak != '' &&
			this.selectedLabel.chinese != '' &&
			this.selectedLabel.italian != ''
		);
	}

	updateLabel(): void {
		if (this.isUpdatingLabel) return;

		if (!this.isAllFieldsFullfiled()) {
			this.NotificationService.setNotificationMessage(this.labels.lbl_preencha_todos_campos);
			return;
		}

		this.isUpdatingLabel = true;

		const body = {
			label: 'lbl_' + this.selectedLabel.id,
			portuguese: this.selectedLabel.portuguese,
			english: this.selectedLabel.english,
			spanish: this.selectedLabel.spanish,
			slovak: this.selectedLabel.slovak,
			chinese: this.selectedLabel.chinese,
			italian: this.selectedLabel.italian,
		};

		this.CustomLabelsService.postCustomLabel(body).subscribe(
			() => {
				this.isUpdatingLabel = false;
				this.NotificationService.setNotificationMessage(this.labels.lbl_successful_updated);
			},
			() => {
				this.NotificationService.setNotificationMessage('');
			}
		);
	}

	cleanForm(): void {
		this.selectedLabel = {
			id: this.selectedLabel.id,
			portuguese: '',
			english: '',
			spanish: '',
			slovak: '',
			chinese: '',
			italian: '',
		};
	}

	sort(sortDown: boolean): void {
		const language = this.ProfileService.userData().language.toLowerCase();
		this.labelLoad.sort((a, b) => {
			if (a[language] > b[language]) return sortDown ? -1 : 1;
			if (b[language] > a[language]) return sortDown ? 1 : -1;
			return 0;
		});
	}
}
